import React from 'react'
import { Button } from '@mantine/core'
import { useLocation, useNavigate } from 'react-router-dom'

import { ContactTable } from './ContactTable'

const UPLOAD_LIMIT = 5000
const UPLOAD_LIMIT_MESSAGE = `You can only upload ${UPLOAD_LIMIT} contacts at a time. Please split your CSV file into smaller files and try again.`
const ContactReviewTable: React.FC<any> = (props: any) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { contacts, payload, mutation } = props
  const [clicked, setClicked] = React.useState(false)
  const onUpload = async () => {
    setClicked(true)
    const { importId } = await mutation.mutateAsync(payload as any)
    navigate(`${location.pathname.replace(/review/, '')}upload/${importId}`)
  }
  const isOverLimit = contacts?.length > UPLOAD_LIMIT
  const hasAnyErrors = contacts?.some((contact: any) => contact.validationErrors.length)

  return (
    <div className={`card`}>
      <ContactTable
        contacts={
          hasAnyErrors
            ? contacts.filter((contact: any) => contact.validationErrors.length)
            : contacts
        }
        title={
          isOverLimit
            ? UPLOAD_LIMIT_MESSAGE
            : !hasAnyErrors
              ? `Review CSV import: ${contacts.length} contacts`
              : `Invalid contacts`
        }
      />

      <div className='card-footer'>
        <button
          type='submit'
          className='btn btn-primary'
          onClick={onUpload}
          disabled={hasAnyErrors || clicked || isOverLimit}
        >
          {mutation.isLoading && (
            <span className='spinner-border spinner-border-sm align-middle mx-2' />
          )}
          Continue
        </button>
        <Button onClick={() => navigate(-1)} className='btn btn-secondary mx-10'>
          Cancel & Re-upload CSV
        </Button>
      </div>
    </div>
  )
}

export { ContactReviewTable }
